export default [
"1f600.png",
"1f601.png",
"1f602.png",
"1f603.png",
"1f604.png",
"1f605.png",
"1f606.png",
"1f607.png",
"1f608.png",
"1f609.png",
"1f610.png",
"1f611.png",
"1f612.png",
"1f613.png",
"1f614.png",
"1f615.png",
"1f616.png",
"1f617.png",
"1f618.png",
"1f619.png"
];